import * as React from "react";
import { forwardRef } from "react";
const SvgXDisabled = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 9, height: 9, viewBox: "0 0 9 9", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#7a7a7a", fillRule: "nonzero", stroke: "#7a7a7a", strokeWidth: 0.75, d: "M7.839.522L4.49 3.87 1.144.522l-.63.63L3.86 4.5.513 7.848l.63.63L4.492 5.13 7.84 8.478l.63-.63L5.122 4.5l3.347-3.348z" }));
const ForwardRef = forwardRef(SvgXDisabled);
export default ForwardRef;
